import { queryChildTopics } from "@/api/http";



queryChildTopics("Concept").then(res => {
  // console.log(res);
  let zhi = res.childs.map(el => {
    return {
      topicName: el.topicName,
      topicNumber: el.topicNumber,
      childs: el.childs.map(el => {
        return {
          topicName: el.topicName,
          topicNumber: el.topicNumber,
        }
      })
    }
  })
  localStorage.setItem('concept', JSON.stringify(zhi))
})